import * as Sentry from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { sentryBeforeSend } from "./lib/sentry.shared.js";

const dsn = typeof __SENTRY_DSN__ === "string" ? __SENTRY_DSN__.trim() : "";
if (dsn) {
  Sentry.init({
    dsn,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
    beforeSend: sentryBeforeSend,
    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
    ],
  });
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});